<template>
  <div class="container-fluid mt-2">
    <h2>Benutzer</h2>
    <div role="toolbar" class="btn-toolbar justify-content-between">
      <div class="btn-group">
        <button class="btn btn-secondary" @click="prevPage" id="prev"><font-awesome-icon icon="chevron-left"/></button>
        <button class="btn btn-secondary" @click="nextPage" id="next"><font-awesome-icon icon="chevron-right"/></button>
      </div>
      <button id="new" @click="addUser()" class="btn btn-secondary">Hinzuf&uuml;gen</button>
    </div>
    <b-table @row-clicked="openUser" class="mt-3" striped hover :fields="fields" :items="rows">
    </b-table>
  </div>
</template>

<script>
import router from '@/router'
import sysuser from '@/modules/sysuser.js'

export default {
  name: 'UserList',
  data() {
    return {
      fields: [
        { key: 'id', label: 'ID'},
        { key: 'firstname', label: 'Vorname'},
        { key: 'lastname', label: 'Nachname'},
        { key: 'email', label: 'E-Mail' },
      ],
      rows: []
    }
  },
  created: function() {
    this.fetchData();
  },
  methods: {
    fetchData: function() {
      var self = this;
      sysuser.list(function(data) {
        self.rows = data;
      })
    },
    openUser: function(row) {
      router.push({name: 'UserEditor',params: {userid:row.id}});
    },
    addUser: function() {
      console.log('add user');
      router.push({name: 'UserEditor',params: {userid:'new'}});
    },
    prevPage: function() {
      if (sysuser.viewparams.page > 1) {
        sysuser.viewparams.page--;
        this.fetchData();
      }
    },
    nextPage: function() {
      if (this.rows.length > 0) {
        sysuser.viewparams.page++;
        this.fetchData();
      }
    },
  }
}
</script>
